(function() {
  var Base,
    slice = [].slice,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Base = App.loadClass('core::Services/MapLayers/Base');

  exports.register = function(module) {
    return module.factory('Core.Services.MapLayers.CombinedLayers', [
      '$http', 'Core.Services.Map', '$q', function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return {
          "new": function() {
            var service;
            service = (function(func, args, ctor) {
              ctor.prototype = func.prototype;
              var child = new ctor, result = func.apply(child, args);
              return Object(result) === result ? result : child;
            })(exports.CombinedLayers, args, function(){});
            service.geojson = null;
            return service;
          }
        };
      }
    ]);
  };

  exports.CombinedLayers = (function(superClass) {
    extend(CombinedLayers, superClass);

    function CombinedLayers() {
      this._property = bind(this._property, this);
      this.propertyTable = bind(this.propertyTable, this);
      return CombinedLayers.__super__.constructor.apply(this, arguments);
    }

    CombinedLayers.prototype.url = 'backend/grower/layers/planting-rx/get-cropped-polygons';

    CombinedLayers.prototype.propertyTable = function(ft, layer) {
      var info, props;
      if (ft.properties != null) {
        props = ft.properties;
        info = "<table class='table table-condensed margin-top-22'>";
        info += this._property('Area (ac)', props.acres);
        if (props.productivity) {
          info += this._property('Avg Yield', props.productivity);
        }
        if (props.musym) {
          info += this._property('Soil Type', props.musym);
        }
        if (props.soil_yield) {
          info += this._property('Soil Yield', props.soil_yield);
        }
        if (props.irrigated) {
          info += this._property('Irrigated', '');
        }
        info += '</table>';
      }
      return layer.bindPopup(info);
    };

    CombinedLayers.prototype._property = function(key, val) {
      return "<tr> <td><strong>" + key + "</strong></td> <td>" + val + "</td> </tr>";
    };

    return CombinedLayers;

  })(Base);

}).call(this);
